import { render } from "./labValidationRule.vue?vue&type=template&id=efd34db8&scoped=true"
import script from "./labValidationRule.js?vue&type=script&lang=js"
export * from "./labValidationRule.js?vue&type=script&lang=js"

import "./labValidationRule.vue?vue&type=style&index=0&id=efd34db8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd34db8"]])

export default __exports__